import { create } from 'zustand';

type ModalMode = 'open' | 'minimized' | 'closed';

interface VideoStateModalState {
  mode: ModalMode;
  influencerId: number;
  folderId: number | null;
  onSuccess?: () => void;
  open: (
    influencerId: number,
    folderId: number | null,
    onSuccess?: () => void,
  ) => void;
  close: () => void;
  minimize: () => void;
  maximize: () => void;
}

export const useVideoStateModalStore = create<VideoStateModalState>((set) => ({
  mode: 'closed',
  influencerId: 0,
  folderId: null,
  onSuccess: undefined,
  open: (
    influencerId: number,
    folderId: number | null,
    onSuccess?: () => void,
  ) => {
    return set({
      mode: 'open',
      influencerId,
      folderId: folderId || null,
      onSuccess,
    });
  },
  close: () => {
    return set({ mode: 'closed', influencerId: 0, folderId: null });
  },
  minimize: () => {
    return set({ mode: 'minimized' });
  },
  maximize: () => {
    return set({ mode: 'open' });
  },
}));
